import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form',
  styleUrl: 'form.css',
  shadow: false,
})
export class Form {
  @Prop() formId: string = 'formID';
  @Prop() formMethod: string = 'Link';
  @Prop() formAction: string = 'lookup';
  @Prop() formName: string = 'name';
  @Prop() maxWidth: string = 'auto';
  @Prop() formLayout: string = 'horizontal';

  render() {
    return (
      <form
        class={`form ${this.formLayout}`}
        id={this.formId}
        method={this.formMethod}
        name={this.formName}
        action={this.formAction}
        style={{'max-width': this.maxWidth}}
      >
        <slot />
      </form>
    );
  }
}
